var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test"},[_c('portlet',{scopedSlots:_vm._u([{key:"body",fn:function(){return undefined},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }